import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen } from "@phosphor-icons/react";
import PortalKnowledgeBase from "../components/PortalKnowledgeBase";

export default function InHouseHelpPage() {
  return (
    <div className="max-w-4xl mx-auto space-y-5" data-testid="in-house-help-page">
      <div>
        <Link to="/my-work" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground mb-3" data-testid="in-house-help-back-to-work">
          <ArrowLeft size={12} /> My Work
        </Link>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-2">
          <BookOpen size={28} weight="duotone" className="text-primary" /> Help
        </h1>
        <p className="text-sm text-muted-foreground mt-1">Your operative guide — arriving, photos, checklists, expenses, routes and more.</p>
      </div>
      <PortalKnowledgeBase
        role="in_house"
        testIdPrefix="in-house-help"
        placeholder="Search help — e.g. arrive, expenses, route planner…"
        intro={{ title: "Operative guides", text: "Everything you can do from My Work: reading a job, checking in on site, photos and checklists, completing, expenses, purchase orders, your schedule and route." }}
      />
    </div>
  );
}
